import { MutableRefObject, RefObject, forwardRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { toast } from 'react-toastify';

interface PrintButtonProps {
  ref: RefObject<HTMLElement>;
  title?: string;
  filename?: string;
  isOutline?: boolean;
  iconName?: string;
  className?: string;
  isLoading?: boolean;
  isDanger?: boolean;
  large?: string;
  small?: string;
  margin?: string;
  disabled?: boolean;
}

const PrintButton = forwardRef<HTMLTableElement, PrintButtonProps>(
  (
    {
      title,
      filename,
      isOutline,
      iconName,
      className,
      small,
      disabled = false,
      margin,
      isLoading = false,
      isDanger = false
    },
    ref
  ) => {
    const handlePrint = useReactToPrint({
      documentTitle: `${filename || 'tms' + moment().format('YYYY-MM-DD')}`,
      onPrintError: (errorLocation, error) => {
        toast.error(`Print error at ${errorLocation}: ${error.message}`);
      },
      content: () => (ref as MutableRefObject<HTMLTableElement>).current

      // contentRef: printRef as RefObject<ContentNode>
    });

    return (
      <button
        type={'button'}
        className={`btn btn-${isOutline ? 'outline-' : ''}${
          isDanger ? 'danger ' : 'primary '
        } add-btn 
        ${small} ${margin && margin}`}
        id="print-btn"
        onClick={() => {
          handlePrint();
        }}
        disabled={disabled}
      >
        <div className="d-flex align-items-center justify-content-center">
          {iconName && <i className={`${iconName} align-bottom me-1`} />}
          {title || 'Print'}
          {isLoading && (
            <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          )}
        </div>
      </button>
    );
  }
);

export default PrintButton;
